import React from 'react';
import Layout from './src/components/layout';

import 'prismjs/themes/prism-solarizedlight.css';

export function wrapPageElement({ element }) {
  return <Layout>{element}</Layout>;
}
